
export default function Products() {
  return (
    <div className="bg-white py-24 px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-2 h-2 rounded-full bg-purple-600"></div>
            <span className="text-xs text-gray-500 font-semibold tracking-widest uppercase">Our Products</span>
          </div>
          <h2 className="text-6xl font-bold text-gray-900 mb-4">VPN & Cleaner Applications</h2>
          <p className="text-base text-gray-600">Designed for enhanced security and optimal performance</p>
        </div>

        {/* Product Cards */}
        <div className="grid grid-cols-2 gap-10" data-product-shop>
          {/* VPN Product Card */}
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden transition-transform duration-300 hover:scale-105 hover:shadow-xl">
            <div className="relative h-80 bg-gradient-to-br from-blue-500 to-cyan-400 flex items-center justify-center">
              <img
                src="https://public.readdy.ai/ai/img_res/522f81ad7d522b13d1537739bcdfefe4.jpg"
                alt="VPN Solution"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-8 bg-white">
              <h3 className="text-3xl font-bold text-gray-900 mb-4">VPN Solution</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-6">
                Protect your online privacy with our advanced VPN technology. Enjoy secure browsing, encrypted connections, and access to global content with lightning-fast speeds and military-grade encryption.
              </p>
              <div className="flex gap-2 flex-wrap">
                <span className="px-4 py-2 bg-blue-50 text-blue-700 text-xs font-medium rounded-full whitespace-nowrap">Secure</span>
                <span className="px-4 py-2 bg-cyan-50 text-cyan-700 text-xs font-medium rounded-full whitespace-nowrap">Fast</span>
                <span className="px-4 py-2 bg-indigo-50 text-indigo-700 text-xs font-medium rounded-full whitespace-nowrap">Private</span>
              </div>
            </div>
          </div>

          {/* Cleaner Product Card */}
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden transition-transform duration-300 hover:scale-105 hover:shadow-xl">
            <div className="relative h-80 bg-gradient-to-br from-purple-500 to-pink-400 flex items-center justify-center">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20device%20cleaning%20optimization%20icon%20illustration%20with%20sparkle%20effects%20and%20performance%20boost%20symbols%2C%20clean%20simple%20background%20in%20purple%20pink%20gradient%20colors%2C%20professional%20digital%20art%20style%2C%20centered%20composition%2C%20high%20quality%20vector%20style%20artwork&width=600&height=600&seq=cleaner-product-tutto-004&orientation=squarish"
                alt="Device Cleaner"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-8 bg-white">
              <h3 className="text-3xl font-bold text-gray-900 mb-4">Device Cleaner</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-6">
                Optimize your iOS device performance with our intelligent cleaner. Remove junk files, manage storage efficiently, and boost your device speed with one-tap cleaning and smart optimization features.
              </p>
              <div className="flex gap-2 flex-wrap">
                <span className="px-4 py-2 bg-purple-50 text-purple-700 text-xs font-medium rounded-full whitespace-nowrap">Efficient</span>
                <span className="px-4 py-2 bg-pink-50 text-pink-700 text-xs font-medium rounded-full whitespace-nowrap">Smart</span>
                <span className="px-4 py-2 bg-fuchsia-50 text-fuchsia-700 text-xs font-medium rounded-full whitespace-nowrap">Fast</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
